import React, { useState } from 'react';
import { Row, Col, FormGroup, Input, Card, Alert, CardBody, CardHeader, Label, Button, Spinner } from 'reactstrap';
import { useReportStudiesPatient } from '../../../hooks/services/useReportStudiesPatient';
import { SearchAsync } from '../../../components/elements/SearchAsync';
import Select from 'react-select';
import '../Bi/styleReport.css'

export const IndexReportStudiesPatients = () => {

    const {
        handleInputChange,
        handleSelectChange,
        start_date,
        end_date,
        setSearchPatientState,
        searchPatientState,
        id_patient,
        handleLoadTable,
        tableData,
        studies, selectedStudy, setSelectedStudy,
        isDownloading, isPatientSelected,
        setIsPatientSelected,
        handleDownloadClick,
        filteredRows, grouped,
        totalPerfiles, totalExamenes, totalAnalitos, totalCambios,
        isLoadingTable, showStudyHint,
        handleClearAll, searchKey, setSearchKey, totalNims,     rows, 



    } = useReportStudiesPatient();

    const options = [
        { value: "", label: "Seleccionar" },
        ...studies.map(study => ({
            value: study.value,
            label: study.label
        }))
    ];

    const dynamicColumns = tableData?.data?.work_orders
        ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        ?.map(w => ({
            field: w.nim,
            header: (
            <div className="header-nim">
                <span className="nim">{w.nim}</span>
                <span className="fecha">{w.created_at_text}</span>
            </div>
            )
        })) || [];


    const isDownloadDisabled = !id_patient || isDownloading || !tableData;
    
    const filteredDynamicColumns = React.useMemo(() => {

        if (!selectedStudy || selectedStudy === "ALL") {
            return dynamicColumns;
        }

        const isValidValue = (value) => {
            if (value === null || value === undefined) return false;

            const clean = String(value).trim();

            return (
                clean !== "" &&
                clean !== "-" &&
                clean !== "**" &&
                clean !== "null"
            );
        };

        return dynamicColumns.filter((col, index) => {

            if (index === 0) return true;

            const hasData = rows.some(row => isValidValue(row[col.field]));

            return hasData;
        });

    }, [dynamicColumns, rows, selectedStudy]);;
        
    return (
        <Col sm="12">
            <Card style={{
                marginBottom: '15px',
                background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                border: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}>
                <CardBody style={{ padding: '18px 25px' }}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '15px'
                            }}>
                                <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/report-patient.png")} style={{ width: "44px", height: "44px" }} />
                            </div>
                            <div>
                                <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '17px', textAlign: "justify" }}>
                                    Histórico por pacientes
                                </h4>
                                <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '12px' }}>
                                    <i className="fa fa-info-circle mr-1"></i>
                                    Reporte para comparar resultados de exámenes y perfiles en el rango de fechas seleccionado.
                                </small>
                            </div>
                        </div>

                    </div>
                </CardBody>
            </Card>


            <Card className=' height-equal mb-0 pb-0'
            >
                <div className='container-global-zoom'>

                    <Row>

                        <Col md="12" sm="12" className=''>
                            <Card className='card-report shadow-sm border pt-1 mb-0 pb-0' >

                                <CardBody style={{ padding: '15px' }}>


                                    <Row className="align-items-start g-2 pt-2">

                                        {/* PACIENTE */}
                                        <Col md="3" sm="12">
                                            <Label style={{ fontSize: "13px", fontWeight: "700" }}>Paciente <span style={{ color: "rgb(0, 103, 199)", fontSize: "14px" }}>*</span></Label>

                                            <div style={{
                                                border: !isPatientSelected ? "1px solid #f04438" : "1px solid #ffffff",
                                                borderRadius: "8px",
                                                padding: "2px"
                                            }}>
                                               <div className="search-top-layer">
                                                <SearchAsync
                                                        name="id_patient"
                                                        key={searchKey}
                                                        method={(option) => {
                                                            handleSelectChange(option);
                                                            setIsPatientSelected(true);
                                                        }}
                                                        loincState={searchPatientState}
                                                        setLoincState={setSearchPatientState}
                                                        url="Patient/SearchPatient"
                                                        placeholder='Búsqueda por nombre o curp'
                                                        isClearable
                                                        menuPortalTarget={document.body}
                                                    />
                                                </div>
                                                
                                            </div>

                                            {!isPatientSelected && (
                                                <div style={{ marginTop: "6px" }}>
                                                    <span style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "6px",
                                                        fontSize: "12px",
                                                        color: "#b42318",
                                                        background: "#fef3f2",
                                                        padding: "4px 10px",
                                                        borderRadius: "999px",
                                                        border: "1px solid #fecdca",
                                                        fontWeight: 500
                                                    }}>
                                                        <span style={{
                                                            width: "6px",
                                                            height: "6px",
                                                            background: "#f04438",
                                                            borderRadius: "50%"
                                                        }}></span>

                                                        Debes seleccionar un paciente
                                                    </span>
                                                </div>
                                            )}
                                        </Col>

                                        {/* FECHA INICIO */}
                                        <Col md="2" sm="6">
                                            <Label style={{ fontSize: "13px", fontWeight: "700" }}>Fecha inicio</Label>
                                            <Input
                                                type="date"
                                                name="start_date"
                                                value={start_date}
                                                onChange={handleInputChange}
                                                className="input-admision mt-2"
                                            />
                                        </Col>

                                        {/* FECHA FIN */}
                                        <Col md="2" sm="6">
                                            <Label style={{ fontSize: "13px", fontWeight: "700" }}>Fecha fin</Label>
                                            <Input
                                                type="date"
                                                name="end_date"
                                                value={end_date}
                                                onChange={handleInputChange}
                                                className="input-admision mt-2"
                                            />
                                        </Col>

                                        {studies.length > 0 && (
                                            <Col md="3" sm="6">
                                                <div className={`study-wrapper ${showStudyHint ? "study-highlight-soft" : ""}`}>

                                                    <Label style={{ fontSize: "13px", fontWeight: "700" }}>Estudio</Label>


                                                    <Select
                                                        options={options}
                                                        value={options.find(opt => opt.value === selectedStudy) || null}
                                                        onChange={(option) => setSelectedStudy(option?.value || "")}
                                                        placeholder="Seleccionar"
                                                        classNamePrefix="react-select"
                                                        className="mt-2"
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                            control: (base, state) => ({
                                                                ...base,
                                                                borderRadius: '8px',
                                                                border: showStudyHint
                                                                    ? '1px solid #0569ff'
                                                                    : '1px solid #ddd',
                                                                padding: '1px',
                                                                fontSize: '13px',
                                                                boxShadow: state.isFocused ? '0 0 0 1px #0569ff' : 'none',
                                                                '&:hover': {
                                                                    borderColor: '#0569ff'
                                                                }
                                                            })
                                                        }}

                                                    />


                                                    {studies[0]?.value === "EMPTY" && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            <span style={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                fontSize: "12px",
                                                                color: "#b42318",
                                                                background: "#fef3f2",
                                                                padding: "4px 10px",
                                                                borderRadius: "999px",
                                                                border: "1px solid #fecdca",
                                                                fontWeight: 500
                                                            }}>
                                                                <span style={{
                                                                    width: "6px",
                                                                    height: "6px",
                                                                    background: "#f04438",
                                                                    borderRadius: "50%"
                                                                }}></span>

                                                                Sin estudios encontrado para el paciente
                                                            </span>
                                                        </div>
                                                    )}

                                                </div>
                                            </Col>
                                        )}

                                        {/* BOTONES */}
                                        <Col md="2" sm="12" className='mt-4'>
                                            <div style={{
                                                display: "flex",
                                                gap: "6px",
                                                alignItems: "center",
                                                height: "100%"
                                            }}>

                                                <Button
                                                    onClick={handleLoadTable}
                                                    disabled={isLoadingTable}
                                                    color="primary"
                                                    className='mt-1'
                                                    style={{
                                                        padding: "10px",
                                                        borderRadius: "8px",
                                                        minWidth: "36px",
                                                        height: "36px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    title='Buscar estudios'
                                                >
                                                    {isLoadingTable
                                                        ? <i className="pi pi-spin pi-spinner"></i>
                                                        : <i className="pi pi-search"></i>}
                                                </Button>

                                                <Button
                                                    onClick={handleDownloadClick}
                                                    disabled={isDownloadDisabled}
                                                    color="success"
                                                    style={{
                                                        padding: "10px",
                                                        borderRadius: "8px",
                                                        minWidth: "36px",
                                                        height: "36px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    className='mt-1'
                                                >
                                                    {isDownloading ? (
                                                        <>
                                                            <i className="pi pi-spin pi-spinner"></i>&ensp;
                                                        </>
                                                    ) : <i className="fa fa-file-excel-o"></i>}
                                                </Button>

                                                <Button
                                                    onClick={() => {
                                                        handleClearAll();
                                                        setSearchKey(prev => prev + 1);
                                                    }}
                                                    color="danger"
                                                    style={{
                                                        padding: "10px",
                                                        borderRadius: "8px",
                                                        minWidth: "36px",
                                                        height: "36px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    className='mt-1'
                                                >
                                                    <i className="fa fa-trash"></i>
                                                </Button>

                                            </div>
                                        </Col>

                                    </Row>
                                </CardBody>
                            </Card>


                        </Col>



                        <Col md="12" sm="12" className='pt-3'>
                            <div style={{ width: "100%" }}>

                                {/* {isDownloading && (
                                    <div className="fade-in">
                                        <Spinner
                                            color="primary"
                                            style={{
                                                width: "4rem",
                                                height: "4rem",
                                                animation: "spin 1s linear infinite"
                                            }}
                                        />
                                        <br /><br />
                                        <div style={{ fontSize: "22px", fontWeight: "700", color: "#0b72e7" }}>
                                            Descargando reporte...
                                        </div>
                                        <small style={{ color: "#006eff", fontSize: "16px" }}>
                                            Esto puede tardar unos segundos
                                        </small>
                                    </div>
                                )} */}
                                {!(tableData && selectedStudy) && (
                                    <div style={{
                                        width: "100%",
                                        height: "70vh",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column"
                                    }}>
                                        <img
                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "40%" }}
                                            alt="Inicio"
                                        />

                                        <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                            Histórico de pacientes
                                        </p>
                                    </div>
                                )}

                                {tableData && selectedStudy && (
                                    <>
                                        <div className="table-footer-report">
                                            {/* <div className="footer-item">
                                                <span className="dot"></span>
                                                <span className='historical-indicators'>{totalPerfiles} Perfiles</span>
                                            </div> */}

                                            <div className="footer-item">
                                                <span className="icon">
                                                    <i className="fa fa-list-ul icon-blue"></i>
                                                </span>
                                                <span className='historical-indicators'>{totalExamenes} Exámenes</span>
                                            </div>

                                            <div className="footer-item">
                                                <span className="icon">
                                                    <i className="fa fa-flask icon-purple"></i>
                                                </span>
                                                <span className='historical-indicators'>{totalAnalitos} Analitos</span>
                                            </div>

                                            <div className="footer-item">
                                                <span className="icon">
                                                    <i className="fa fa-exclamation-triangle icon-yellow"></i>
                                                </span>
                                                <span className='historical-indicators'>{totalCambios} Cambios</span>
                                            </div>

                                            <div className="footer-item mr-2">
                                                <span className="icon">
                                                    <i className="fa fa-hashtag" style={{
                                                        background: "#e98a0e",
                                                        color: "#fff",
                                                        padding: "4px",
                                                        borderRadius: "6px",
                                                        fontSize: "11px"
                                                    }}></i>
                                                </span>
                                                <span className='historical-indicators'>{totalNims} NIMs</span>
                                            </div>

                                            <div className="footer-item">
                                                <span className="result-patient-report"></span>
                                                <span className='historical-indicators'>Resultado reciente</span>
                                            </div>

                                            <div className="footer-page">

                                            </div>
                                        </div>
                                        <div className="table-container-report table-responsive">
                                            <table className="custom-table-report">
                                                <thead>
                                                    <tr>
                                                        <th className="sticky-col">Examen</th>
                                                        <th className="sticky-col-2">Analito</th>
                                                        <th className="sticky-col-3">Cambios</th>

                                                        {filteredDynamicColumns.map((col, i) => (
                                                            <th
                                                                key={i}
                                                                className={i === 0 ? "sticky-dynamic-first-report" : ""}
                                                                style={{
                                                                    ...(i === 0 && {
                                                                    background: "#16a34a",
                                                                    color: "#fff",
                                                                    fontWeight: "700"
                                                                    }),
                                                                }}
                                                            >
                                                                {col.header}
                                                            </th>

                                                            

                                                        ))}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {filteredRows.length === 0 ? (
                                                        <tr>

                                                            <div className="text-center p-4">
                                                                <img
                                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                    style={{ width: "40%" }}
                                                                    alt="Sin resultados"
                                                                />
                                                                <br />
                                                                <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                                    Sin coincidencias encontradas
                                                                </p>
                                                            </div>

                                                        </tr>
                                                    ) : (

                                                        Object.entries(grouped).map(([exams, items], index) => (
                                                            items.map((row, i) => (
                                                                <tr
                                                                    key={`${exams}-${i}`}
                                                                    className={row.cambios === "SI" ? "row-change-report" : ""}
                                                                >

                                                                    {i === 0 && (
                                                                        <td
                                                                            rowSpan={items.length}
                                                                            className="sticky-col label-perfilR"
                                                                        >
                                                                            {exams}
                                                                        </td>
                                                                    )}

                                                                    <td className="sticky-col-2" style={{ fontWeight: "700" }}>{row.analito}</td>

                                                                    <td className="sticky-col-3">
                                                                        <span

                                                                            style={{
                                                                                color: "#fff",
                                                                                backgroundColor: row.cambios === "SI" ? "#ff7300" : "#25acd4",
                                                                                padding: "4px 8px",
                                                                                borderRadius: "12px",
                                                                                fontSize: "12px",
                                                                                display: "inline-block",
                                                                                fontWeight: "700"

                                                                            }}>
                                                                            {row.cambios}
                                                                        </span>

                                                                    </td>

                                                                    {filteredDynamicColumns.map((col, j) => (
                                                                        <td
                                                                            key={j}
                                                                            className={j === 0 ? "sticky-dynamic-first-report cell-recent" : ""}
                                                                        >
                                                                            {row[col.field] ?? "-"}
                                                                        </td>
                                                                    ))}
                                                                </tr>
                                                            ))
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>

                                        </div>
                                    </>
                                )}



                            </div>

                        </Col>


                    </Row>

                </div>
                <br />
            </Card>

        </Col>
    );
};
